<div *ngIf="content.title">
  <div class="skymiles-landing-page-partners">
    <h4 class="skymiles-landing-page-partners__title">{{ content.title }}</h4>
    <idp-link
      *ngIf="content.action.url"
      [label]="content.action.label"
      [axLabel]="content.action.label"
      [actionUrl]="content.action.url"
      class="skymiles-landing-page-partners__action_url"
      [labelSize]="'large'"
    ></idp-link>
    <div class="skymiles-landing-page-partners__content_list">
      <div
        class="skymiles-landing-page-partners__{{ content.status }}"
        *ngFor="let partner of content.items; let index = index"
      >
        <div class="skymiles-landing-page-partners__partner_content">
          <idp-image
            class="skymiles-landing-page-partners__logo"
            [content]="partner.logo"
          ></idp-image>
          <div class="skymiles-landing-page-partners__partner--details">
            <label class="skymiles-landing-page-partners__partner-description">
              {{ partner.title }}
            </label>
            <idp-link
              *ngIf="partner.action.url"
              [id]="partner.id || '#'"
              [label]="partner.action.label"
              [axLabel]="partner.title"
              [actionUrl]="partner.action.url"
              class="skymiles-landing-page-partners__link"
              [labelSize]="'large'"
            ></idp-link>
            <div class="skymiles-landing-page-partners__col-divider"></div>
          </div>
        </div>
        <div class="skymiles-landing-page-partners__row-divider"></div>
      </div>
    </div>
  </div>
</div>
